import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueMapbox from 'vue-mapbox'
import Mapbox from 'mapbox-gl'
import * as Sentry from '@sentry/browser'
import 'vuetify/dist/vuetify.min.css'

Sentry.init({
  dsn: 'https://6f13f186232246d1be4d32227bb09991@sentry.io/1414635',
  integrations: [new Sentry.Integrations.Vue({ 
    Vue,
    attachProps: true
  })]
})

Vue.use(Vuetify)
Vue.use(VueMapbox, { mapboxgl: Mapbox })
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
